import { PropTypes } from "aem/ComponentWrapper";
import React from "react";

export default {
  title: "Sticky",
  type: "rh/components/content/sticky",
  isContainer: true,
  config: {
    emptyLabel: "Sticky",
    isEmpty: ({ children }: PropTypes) => React.Children.count(children) === 0
  }
};
